export const sendEmail = async (emailData) => {
  try {
    const {
      email,
      subject,
      text,
      html,
      cc,
      conversationId,   // NEW
      recipientEmail,   // NEW
      senderName,       // NEW
      type
    } = emailData;

    if (!email || !text) {
      throw new Error('Missing required fields: email and text');
    }

    const requestBody = {
      email: email,
      subject: subject,
      text: text,
      html: html,
    };

    if (cc && cc.trim() !== '') {
      requestBody.cc = cc;
    }

    if (type) {
      requestBody.type = type;
    }

    // 🎯 Send conversation context to backend
    if (conversationId) {
      requestBody.conversationId = conversationId;
    }

    if (recipientEmail) {
      requestBody.recipientEmail = recipientEmail;
    }

    if (senderName) {
      requestBody.senderName = senderName;
    }

    const response = await fetch(`https://hire100x-e1dd4.uc.r.appspot.com/send-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error || `HTTP error! status: ${response.status}`);
    }

    if (!result.success) {
      throw new Error(result.error || 'Email sending failed');
    }

    console.log("Email sent successfully:", result);
    return result;
  } catch (error) {
    console.error("Error sending email:", error);
    throw error;
  }
};

export const sendLeadEmail = async (emailData) => {
  try {
    const {
      email,
      subject,
      text,
      html,
      cc,
      conversationId,
      recipientEmail,
      senderName,
      orgId,
      jobId,
      applicantId,
    } = emailData

    if (!email || !text) {
      throw new Error('Missing required fields: email and text')
    }

    const requestBody = {
      email,
      subject,
      text,
      html,
    }

    if (cc && cc.trim() !== '') requestBody.cc = cc
    if (conversationId) requestBody.conversationId = conversationId
    if (recipientEmail) requestBody.recipientEmail = recipientEmail
    if (senderName) requestBody.senderName = senderName
    if (orgId) requestBody.orgId = orgId
    if (jobId) requestBody.jobId = jobId
    if (applicantId) requestBody.applicantId = applicantId

    const response = await fetch(`https://hire100x-e1dd4.uc.r.appspot.com/send-email/to-lead`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    })

    const result = await response.json()

    if (!response.ok) {
      throw new Error(result.error || `HTTP error! status: ${response.status}`)
    }

    if (!result.success) {
      throw new Error(result.error || 'Email sending failed')
    }

    console.log('Lead email sent successfully:', result)
    return result
  } catch (error) {
    console.error('Error sending lead email:', error)
    throw error
  }
}
